import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AlertCircle, X } from 'lucide-react'

interface SessionExpirySnackbarProps {
  message?: string
}

export function SessionExpirySnackbar({
  message,
}: SessionExpirySnackbarProps) {
  const { t } = useTranslation('app')
  const [dismissed, setDismissed] = useState(false)
  const body = message ?? t('audienceCreate.identityWorkspaceExpiry')

  if (dismissed) return null

  return (
    <div className="fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-4 pointer-events-none">
      <div className="pointer-events-auto flex w-full max-w-2xl items-start gap-3 rounded-lg border border-border/40 bg-[#1a1f1f] px-4 py-3 shadow-lg">
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <div className="flex-1 space-y-0.5">
          <p className="text-sm font-semibold text-white">{t('audienceCreate.sessionExpiresSoon')}</p>
          <p className="text-sm text-muted-foreground">{body}</p>
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="shrink-0 rounded p-0.5 text-muted-foreground transition-colors hover:text-foreground"
          aria-label={t('audienceCreate.dismiss')}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  )
}
